import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { Button } from 'primeng/button';
import { providePrimeNG } from 'primeng/config';
import { PRIMENG_DARK_MODE_CLASS } from './primeng-dark-mode';
import { provideEagerPrimeNgStyles } from './primeng-eager-styles';

const SHADES = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950] as const;

// Lara defaults to an emerald primary; the app has always been blue (saga-blue).
const LaraBlue = definePreset(Lara, {
  semantic: {
    primary: Object.fromEntries(SHADES.map((shade) => [shade, `{blue.${shade}}`])),
  },
});

/**
 * No cssLayer: unlayered global resets (e.g. `a { background-color: transparent }`) would
 * beat every layered PrimeNG rule. Unlayered, specificity decides, as with the old theme CSS.
 */
export function providePrimeNgTheme(): EnvironmentProviders {
  return makeEnvironmentProviders([
    providePrimeNG({
      theme: {
        preset: LaraBlue,
        options: {
          darkModeSelector: `.${PRIMENG_DARK_MODE_CLASS}`,
        },
      },
    }),
    // Grid cell renderers build p-button markup as HTML strings, with no PrimeNG button to load it.
    provideEagerPrimeNgStyles(Button),
  ]);
}
